// extracted by mini-css-extract-plugin
module.exports = {"clear-btn":"clear-selected_clear-btn__p5FD8","mobile":"clear-selected_mobile__JC0zc"};